import { dictionaries } from '../i18n/index.js';
import { Locale } from '../i18n/translatable.js';
import { getTexts, tlmdSchema } from './index.js';
import { Operation, InputType } from './schema.types.js';
export const getFormControlDefinitions = (tlmdSchema, operation) => {
    if (tlmdSchema && tlmdSchema.properties) {
        return Object.keys(tlmdSchema.properties).reduce((controlMap, propertyName) => {
            controlMap[propertyName] = getFormControlDefinition(propertyName, tlmdSchema, operation);
            return controlMap;
        }, {});
    }
    else {
        return {};
    }
};
export const getFormTexts = (tlmdSchema, locale) => {
    const dictionary = dictionaries[locale] ?? dictionaries.en;
    return getTexts(tlmdSchema, locale, dictionary, tlmdSchema, undefined);
};
const getFormControlDefinition = (propertyName, schema, operation) => {
    const propertyDef = schema.properties[propertyName];
    const propertySchema = tlmdSchema(propertyDef.ref);
    const propertyTexts = getTexts(propertySchema, Locale.en, dictionaries.en, schema, propertyName);
    let inputDefinition = undefined;
    let inputDisabled = false;
    if (propertySchema.input && propertyDef.usage && propertyDef.usage[operation] !== undefined) {
        const input = propertyDef.usage[operation];
        if (input !== undefined) {
            if (input === 0) {
                //Hidden input
                inputDefinition = { type: InputType.Hidden };
            }
            else {
                if (!propertySchema.input.pop && Math.abs(input) === 1) {
                    inputDefinition = propertySchema.input;
                }
                else {
                    if (propertySchema.input.length >= Math.abs(input)) {
                        inputDefinition = propertySchema.input[Math.abs(input) - 1];
                    }
                }
                if (inputDefinition) {
                    inputDisabled = input < 0;
                }
            }
        }
    }
    return {
        name: propertyName,
        definition: propertyDef,
        schema: propertySchema,
        input: inputDefinition
            ? Object.assign({ disabled: inputDisabled }, inputDefinition)
            : undefined,
        texts: propertyTexts
    };
};
